module.exports = __webpack_public_path__ + "img/bg.bb3cc194.png";